<app-header></app-header>
<main class="ep">
  <div class="ep-card" role="alert">
    <span class="ep-icon" aria-hidden="true">
      @if (notFound) {
        <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M15.5 8.5 13.4 13.4 8.5 15.5l2.1-4.9 4.9-2.1Z" />
        </svg>
      } @else {
        <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3.5 21 19.5H3L12 3.5Z" />
          <path d="M12 10v4.2M12 16.9h.01" />
        </svg>
      }
    </span>

    <div class="ep-kicker">{{ notFound ? 'Error 404' : 'Error' }}</div>
    <h1 class="ep-title">{{ notFound ? "We couldn't find that page" : 'Something went wrong' }}</h1>

    @if (notFound) {
      <div class="ep-text">The link may be old, or the address mistyped.</div>
      <div class="ep-address">
        <span class="ep-address-label">Address</span>
        <code>{{ requested }}</code>
      </div>
    } @else {
      <div class="ep-text">{{ errorMessage }}</div>
    }

    <div class="ep-actions">
      <button type="button" class="btn btn-theme" (click)="goHome()">Go to home</button>
      @if (notFound) {
        @if (canGoBack) {
          <button type="button" class="btn btn-dark" (click)="goBack()">Go back</button>
        }
      } @else {
        <button type="button" class="btn btn-dark" (click)="reload()">Try again</button>
      }
    </div>

    <div class="ep-help">
      Still stuck? Email <a href="mailto:support@worldtumbler.com">support&#64;worldtumbler.com</a>
    </div>
  </div>
</main>
